<template>
  <div class="p-2">
    <div class="flex justify-between items-center mb-4">
      <span>Conversations</span>
      <button @click="showModal" class="btn btn-defaut btn-sm">New Conversation</button>
    </div>
    <ul>
      <li class="flex justify-between gap-x-6 py-5" v-for="conversation in data.conversations">
        <a :href="`${baseUrl}/conversations/${conversation.id}`" class="flex min-w-0 gap-x-4">
          <div class="rounded-full">

          </div>
          <div class="min-w-0 flex-auto">
            <p class="text-sm/6 font-semibold">{{ conversation?.title || conversation?.work_order?.customer?.name || conversation?.work_order?.machine?.name}}</p>
            <p class="mt-1 truncate text-xs/5">{{ conversation?.last_message  }}</p>
          </div>
        </a>
        <div class="flex space-x-2">
          <div class="w-7 h-7 rounded-full dark:bg-amber-300 dark:text-black flex items-center justify-center" v-for="user in conversation.users">
            {{user.email[0]}}
          </div>
        </div>
      </li>

    </ul>
    <dialog ref="modal" class="modal z-90 top-12 absolute">
      <div class="modal-box top-12">
        <h3 class="title text-sm font-light my-2">Search work orders</h3>
        <form>
          <div class="form-control">
            <input @keyup.prevent="searchWorkOrder($event)" type="text" placeholder="Name"
                   class="input input-bordered w-full"/>
          </div>
        </form>
        <ul class="max-h-48">
          <li class="py-2 my-2"
              v-for="wo in workOrders"
              :key="wo.id">
            <div class="flex justify-between items-center">
              <span class="text-sm">{{ wo.title }}</span>
              <div class="space-y-2">
                <div class="text-xs flex items-center space-x-2 text-gray-500" v-if="wo.customer">
                  <div class="w-5 h-5 rounded-full bg-white flex items-center justify-center">
                    C
                  </div>
                  <span class="mx-1">{{ wo.customer.name }}</span>
                </div>
                <div class="text-xs flex items-center space-x-2 text-gray-500" v-if="wo.machine">
                  <div class="w-5 h-5 rounded-full bg-white flex items-center justify-center">
                    M
                  </div>
                  <span class="mx-1">{{ wo.machine.name }}</span>
                </div>
              </div>
              <span>
                {{ wo.created_at }}
              </span>
              <button @click.prevent="createConversation(wo)" class="btn btn-sm btn-primary">
                  +
              </button>
            </div>

          </li>
        </ul>

        <div class="modal-action">
          <form method="dialog">
            <!-- if there is a button in form, it will close the modal -->
            <button class="btn">Close</button>
          </form>
        </div>
      </div>
    </dialog>
  </div>

</template>
<script setup>
import {ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {csrf} from '~/lib/tools';

const modal = ref(null);
let route = useRoute();
let router = useRouter();
let data = ref({
  conversations: []
});
let workOrders = ref([]);
let showModal = () => {
  modal.value.showModal();
}
let organizationId = route.params.organization_uuid;
let baseUrl = `/dashboard/organizations/${organizationId}`;
let searchWorkOrder = (e) => {
  fetch(`/dashboard/organizations/${organizationId}/work_orders.json?q=${e.target.value}`)
      .then(r => r.json())
      .then(r => {
        workOrders.value = r.data;
      });
}
let fetchConversations = () => {
  fetch(`${baseUrl}/conversations.json`).then(r => r.json()).then(r => {
    console.log(r);
    data.value.conversations = r.data;
  })
}
let createConversation = async (work_order) => {
  const res = await fetch(`${baseUrl}/conversations.json`, {
    method: "post",
    body: JSON.stringify({
      conversation: {
        work_order_id: work_order.id,
        kind: 'work_order',
        name: work_order.name,
      }
    }),
    headers: {
      'Content-type': 'application/json',
      "X-CSRF-Token": csrf()
    },
    credentials: "same-origin"
  })
  if (!res.ok) throw new Error("Failed to remove participant");
    router.push({path: `${res.headers.get("Location")}`});
}
fetchConversations();
</script>